/** US states and DC (50 states + District of Columbia). */
export const US_STATE_CODES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
  'DC',
] as const;

/** US territories and non-US catch-all — always shown after states; Other is last. */
export const US_TERRITORY_AND_OTHER_OPTIONS = [
  { value: 'AS', labelKey: 'state-option-as' },
  { value: 'PR', labelKey: 'state-option-pr' },
  { value: 'GU', labelKey: 'state-option-gu' },
  { value: 'VI', labelKey: 'state-option-vi' },
  { value: 'MP', labelKey: 'state-option-mp' },
  { value: 'Other', labelKey: 'state-option-other' },
] as const;
